const POS_INTEGRATION_LIST = [
  {
    name: 'Carezone Wellness\nAtria Mall',
    outlet: 'AtriaMall_CarezoneWellness',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'DK Style\nCQC',
    outlet: 'CQC_DkStyle',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Glow Couture\nCQC',
    outlet: 'CQC_GlowCouture',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Hanami Barber\nCQC',
    outlet: 'CQC_HanamiBarber',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Head and Wellness by Glow Couture\nCQC',
    outlet: 'CQC_HeadAndWellnessByGlowCouture',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Kojimaya\nCQC',
    outlet: 'CQC_Kojimaya',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Agnes G Nails (PLQ Mall)',
    outlet: 'DCS_AgnesGNails_PLQMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'DE.MICARE',
    outlet: 'DCS_DeMicare',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'GEM Studio',
    outlet: 'DCS_GemStudio',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Historia',
    outlet: 'DCS_HistoriaHairSalon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  // {
  //   name: 'Huuk Barbershop (IOI Mall)',
  //   outlet: 'DCS_HuukBarbershop',
  //   account: ['kw@tunai', 'king.auto@tunai'],
  // },
  {
    name: 'Huuk Barbershop (Sunway Pyramid)',
    outlet: 'DCS_HuukBarbershopSunway',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Huuk Barbershop - Wangsa Walk (G-40)',
    outlet: 'DCS_HuukBarbershop_WangsaWalk_G_40',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Huuk Barbershop - Wangsa Walk (L1-63C)',
    outlet: 'DCS_HuukBarbershop_WangsaWalk_L1_63C',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'James Barker Barber',
    outlet: 'DCS_JamesBarkerBarber',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Organic Hair Regrowth Solutions (Paya Lebar Quarter)',
    outlet: 'DCS_OrganicHairRegrowthSolutions',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Organic Hair Regrowth Solutions (Star Vista)',
    outlet: 'DCS_OrganicHairRegrowthSolutions_StarVista',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Starlight',
    outlet: 'DCS_Starlight',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Eskapinc\nEurostop',
    outlet: 'Eurostop_Eskapinc',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Wax Zone (Main Place Mall)\nTEQ',
    outlet: 'TEQ_WaxZone',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Jenn Ortho',
    outlet: 'DCS_JennOrtho',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Alano Hair Studio\nJB City Square Mall',
    outlet: 'JBCitySquareMall_Alano',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Brown Sugar Hair Saloon',
    outlet: 'DCS_BrownSugarHairSaloon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Skinz Sanctuary\nTropicana Gardens Mall',
    outlet: 'DCS_SkinzSanctuary_TropicanaGardensMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Hairover Salon',
    outlet: 'DCS_HairoverSalon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'The Hair TRIC and Lashility\nVimigo',
    outlet: 'Vimigo_Tric',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Lavina's Beauty Salon",
    outlet: 'DCS_Lavina',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Kaloe Beauty Specialist',
    outlet: 'DCS_Kaloe',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Hope Remedies',
    outlet: 'DCS_HopeRemedies',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'One Cosmeceutical\nPOS\nIntegration',
    outlet: 'CQC_OneCosmeceutical',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Bio Tampines\nPOS\nIntegration',
    outlet: 'DCS_BioTampines',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'The Hair TRIC and Lashility\nIOI City\nPOS\nIntegration',
    outlet: 'DCS_HairTric',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Yogle House Beauty\nSG Junction 10\nIntegration',
    outlet: 'SGJunction10_YogleBeauty',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Test POS Integration',
    outlet: 'test_chloe_salon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Cutiecle Nail Express\nIOI City Mall',
    outlet: 'DCS_CutiecleTheNailExperts_IOICityMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Glitz Nail Spa\nEmpire Shopping Gallery',
    outlet: 'DCS_GlitzNailSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "The 50‘s Barbershop\nTropicana",
    outlet: 'DCS_50sBarberShop',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Express Beauty Bar\nNU Sentral",
    outlet: 'NUSentral_ExpressBeautyBar',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Tuesdè',
    outlet: 'DCS_Tuesde',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'AgnesG Nails (Shaw Plaza)',
    outlet: 'DCS_AgnesGNails_ShawPlaza',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Express Beauty Bar',
    outlet: 'DCS_ExpressBeautyBar_DatumJelatekSC',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'The Infinity Hair Art',
    outlet: 'DCS_TheInfinityHairArt_ChinatownPoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Marina Slimming',
    outlet: 'DCS_MarinaSlimming',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Air Hairstyling Group\nMarina One\nIntegration',
    outlet: 'MarinaOne_AirHairstylingGroup',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Tammy Car\nMarina One\nIntegration',
    outlet: 'MarinaOne_TammyCar',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Aura Kasih\nParadigm Mall Johor Bahru\nIntegration',
    outlet: 'ParadigmMallJohorBahru_AuraKasih',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Agnes G Nail',
    outlet: 'ArcherLogic_AgnesGNails',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Hair Tric And Lashility',
    outlet: 'DCS_HairTricAndLashility',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Soloists Hair Salon',
    outlet: 'DCS_SoloistsHairSalon_TRX',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Feng Car Grooming Centre',
    outlet: 'DCS_FengCarGroomingCentre',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Sothys\nTropicana Garden Mall',
    outlet: 'DCS_Sothys_TropicanaGardenMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Soloists Hair Salon\nSky Avenue',
    outlet: 'DCS_SoloistsHairSalon_SkyAvenue',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Nail Market Studio\nDowntown East',
    outlet: 'DCS_NailMarketStudio_DowntownEast',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Tranquility House',
    outlet: 'DCS_TranquilityHouse',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'YL Skincare\nSunway Velocity 2',
    outlet: 'DCS_YLSkincare_SunwayVelocity2',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Yu Plus Solution Lab',
    outlet: 'DTS_YuPlusSolutionLab',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Friends Hair Studio',
    outlet: 'DCS_FriendsHairStudio',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Skinz Sanctuary\nEmpire Subang',
    outlet: 'DCS_SkinzSanctuary_EmpireSubang',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Huuk Barbershop\nTRX',
    outlet: 'DCS_HuukBarbershop_TRX',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Perky Lash',
    outlet: 'JBCitySquareMall_PerkyLash',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Fairytale Art & Craft',
    outlet: 'DCS_Fairytale',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Nana Nails Express\nPavilion Kuala Lumpur',
    outlet: 'DCS_NanaNailsExpress_PavilionKualaLumpur',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Cutiecle The Nail Expert\nThe Mines',
    outlet: 'TheMines_CutiecleTheNailExpert',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'THE MOS\nTropicana Garden Mall',
    outlet: 'DCS_TheMos_TropicanaGardenMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'The Salon\nDpulze',
    outlet: 'Dpulze_TheSalon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Mani Nail Spa',
    outlet: 'ParadigmMallJohorBahru_ManiNailSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Nimroc\nKL East Mall',
    outlet: 'KLEastMall_Nimroc',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Nana Nails Bar\nPavilion Bukit Jalil',
    outlet: 'DCS_NanaNailsBar_PavilionBukitJalil',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Culture A Hairstudio\nWangsa Walk',
    outlet: 'DCS_CultureAHairstudio_WangsaWalk',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Nimroc\nElmina Mall',
    outlet: 'ElminaMall_Nimroc',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Only Laser\nTropicana Garden Mall',
    outlet: 'DCS_OnlyLaser_TropicanaGardenMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Organic Way Salon\nBugis Plus',
    outlet: 'BugisPlus_OrganicWaySalon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Lash Monster',
    outlet: 'DTS_LashMonster',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Cutiecle The Nail Expert\nPavilion Bukit Jalil',
    outlet: 'DCS_CutiecleTheNailExperts_PavilionBukitJalil',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Skinz Sanctuary\nPavilion Bukit Jalil',
    outlet: 'DCS_SkinzSanctuary_PavilionBukitJalil',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Soro External Beauty\nSutera Mall',
    outlet: 'DCS_SoroExternal_SuteraMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Nail Essence\nSutera Mall',
    outlet: 'DCS_NailEssence_SuteraMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Seventeen Beauty Concept\nSutera Mall',
    outlet: 'DCS_SeventeenBeautyConcept_SuteraMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nClementi Mall',
    outlet: 'DCS_PixieNailSpa_ClementiMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nSengkang Square',
    outlet: 'DCS_PixieNailSpa_SengkangSquare',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'W Hair Spa\nParadigm Mall Johor Bahru',
    outlet: 'ParadigmMallJohorBahru_WHair',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'La Brow\nParadigm Mall Johor Bahru',
    outlet: 'ParadigmMallJohorBahru_LaBrow',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Annora Beauty',
    outlet: 'DCS_Annora',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Vspa and Dessert',
    outlet: 'KLCentralWalk_VspaAndDessert',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nParkway Parade',
    outlet: 'LendLease_PixieNailSpa_ParkwayParade',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Hor Men',
    outlet: 'DCS_HorMen',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Maccaire',
    outlet: 'DCS_Maccaire',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nTiong Bahru Plaza',
    outlet: 'DCS_PixieNailSpa_TiongBahruPlaza',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Organic Way Salon\nSengkang Square',
    outlet: 'DCS_OrganicWaySalon_SengkangSquare',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'A Pro Hair Salon',
    outlet: 'DCS_AProHairSalon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nHillion Mall',
    outlet: 'DCS_PixieNailSpa_HillionMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nJurong Point',
    outlet: 'DCS_PixieNailSpa_JurongPoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Joesayap Barbershop',
    outlet: 'DCS_JoesayapBarbershop',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Lashing, The Lash Atelier',
    outlet: 'DCS_LashAtelier',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nChinatown Point',
    outlet: 'DCS_PixieNailSpa_ChinatownPoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Blush Therapeutic',
    outlet: 'DTS_Blush',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nCauseway Point',
    outlet: 'DCS_PixieNailSpa_CausewayPoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'PINC\nWaterway Point',
    outlet: 'DCS_Pinc_WaterwayPoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Miroku\nVimigo POS',
    outlet: 'Vimigo_Miroku',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nNEX',
    outlet: 'DCS_PixieNailSpa_Nex',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Diamond Nail\nEko Cheras Mall',
    outlet: 'EkoCherasMall_DiamondNail',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Cutiecle The Nail Experts\nCentral i-City',
    outlet: 'iCity_CutiecleThenailExperts',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Picota Nail Spa\nION Orchard',
    outlet: 'IONOrchard_PicotaNailSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nNgee Ann City',
    outlet: 'WismaAtria_PixieNailSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nBugis Junction',
    outlet: 'BugisJunction_PixieNailSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Perfect Solution Skin\nDuo Galleria',
    outlet: 'DCS_PerfectSolutionSkin_DuoGalleria',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Qoosh Nail Spa\nWisma Atria',
    outlet: 'WismaAtria_QooshNailSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nGuoco Tower',
    outlet: 'DCS_PixieNailSpa_GuocoTower',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: '31 Hair Studio',
    outlet: 'DCS_31Hair',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Free Skin & Body Perfect\nThe Centrepoint',
    outlet: 'DCS_FreeSkinAndBodyPerfect_CentrePoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Baliayu\nParadigm Mall Petaling Jaya',
    outlet: 'ParadigmMallPetalingJaya_Baliayu',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Miss J Beauty\nSutera Mall)',
    outlet: 'DCS_MissJBeauty_SuteraMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Saw Saloon',
    outlet: 'DCS_SawSaloon',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nNorthpoint City',
    outlet: 'DCS_PixieNailSpa_NorthpointCity',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Lash\nTampines 1',
    outlet: 'DCS_PixieLash_Tampines1',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nTampines 1',
    outlet: 'DCS_PixieNailSpa_Tampines1',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Celmonze\nMarine Parade',
    outlet: 'MarineParade_Celmonze',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'REDS Hairdressing\nParadigm Mall Johor Bahru',
    outlet: 'ParadigmMallJohorBahru_RedsHairdressing',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nWest Coast Plaza',
    outlet: 'DTS_PixieNailSpa_WestCoastPlaza',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Balinese Beauty And Wellness\nLarkin Junction Mall',
    outlet: 'DCS_BalineseBeautyAndWellness_LarkinJunctionMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Thomas & Guys\nSungei Wang',
    outlet: 'SungeiWang_ThomasAndGuys',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nJem',
    outlet: 'DCS_PixieNailSpa_Jem',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Maco Nail Spa\nHolland Village MRT',
    outlet: 'DCS_MacoNailSpa_HollandVillageMRT',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nThe Atrium@Orchard',
    outlet: 'DCS_PixieNailSpa_TheAtriumOrchard',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'LA Barbershop\nVivo City',
    outlet: 'DCS_LABarbershop_VivoCity',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nWest Mall',
    outlet: 'DTS_PixieNailSpa_Westmall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nMarina Square',
    outlet: 'DTS_PixieNailSpa_MarinaSquare',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: 'Pixie Nail Spa\nFunan',
    outlet: 'DCS_PixieNailSpa_Funan',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Buff'd Nail Spa\nMarina Bay Sands",
    outlet: 'DCS_BuffdNailSpa_MarinaBaySand',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Moriso Nails Spa\nKLGCC",
    outlet: 'KLGCC_MorisoNailsSpa',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Pixie Nail Spa\nNovena Square",
    outlet: 'DCS_PixieNailSpa_NovenaSquare',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Ice Bear Shoe Master",
    outlet: 'DCS_IceBearShoeMaster',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Huuk Barbershop (IOI City Mall)",
    outlet: 'DCS_HuukBarbershop_IOICityMall',
    account: ['kw@tunai', 'king.auto@tunai', "chloe.salon@tunai", "tammy@tunai"],
  },
  {
    name: "Pixie Nail Spa (White Sands)",
    outlet: 'DCS_PixieNailSpa_WhiteSands',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Pixie Nail Spa (PLQ Mall)",
    outlet: 'DCS_PixieNailSpa_PLQ',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Pixie Nail Spa (i12 Katong)",
    outlet: 'DCS_PixieNailSpa_i12Katong',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Nimroc (The Campus)",
    outlet: 'TheCampus_Nimroc',
    account: ['kw@tunai', 'king.auto@tunai', 'qistina@tunai'],
  },
  {
    name: "Pixie Nail Spa (Waterway Point)",
    outlet: 'DCS_PixieNailSpa_WaterwayPoint',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Skinz Sanctuary (Sunway Velocity)",
    outlet: 'DCS_SkinzSanctuary_SunwayVelocity',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Nail Air (NEX)",
    outlet: 'DCS_NailAir_NEX',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "DCN Beauty (Paradigm Mall Johor Bahru)",
    outlet: 'ParadigmMallJohorBahru_DCNBeauty',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Black Hair Salon (Capitol Singapore)",
    outlet: 'DCS_BlackHairSalon_CapitolSingapore',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Friends Scalp Solution (Sunway Velocity 2)",
    outlet: 'DCS_FriendsScalpSolution_SunwayVelocity2',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "LA Barbershop (Thomson Plaza)",
    outlet: 'DCS_LABarbershop_ThomsonPlaza',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Jeunex Hair Studio (Pavilion Elite)",
    outlet: 'DCS_JeunexHairStudio_PavilionElite',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Nimroc (KLGCC)",
    outlet: 'KLGCC_Nimroc',
    account: ['kw@tunai', 'king.auto@tunai', 'qistina@tunai'],
  },
  {
    name: "Bio Organicare (Plaza Singapura)",
    outlet: 'DCS_BioOrganicare_PlazaSingapura',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Noble Pro Car Wash (Sunway Square)",
    outlet: 'DCS_NobleProcarWash_SunwaySquare',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Luxe Prestige (SKS City Mall JBCC)",
    outlet: 'DCS_LuxePrestige_SKSCityMallJBCC',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Luxe Nail (SKS City Mall JBCC)",
    outlet: 'DCS_LuxeNail_SKSCityMallJBCC',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Nail Bar / Prostyle / Stay B (SKS City Mall JBCC)",
    outlet: 'DCS_Nailbar_Prostyle_StayB_SKSCityMallJBCC',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Organic Mode Salon (SKS City Mall JBCC)",
    outlet: 'DCS_OrganicModeSalon_SKSCityMallJBCC',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "E.Ex Hair (SKS City Mall JBCC)",
    outlet: 'DCS_EExHair_SKSCityMallJBCC',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Face Wash Cat (Sunway Putra)",
    outlet: 'DCS_FaceWashCat_SunwayPutra',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Cocoon Hair (JB City Square Mall)",
    outlet: 'JBCitySquareMall_CocoonHair',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Pixie Nail Spa (The Woodleigh Mall)",
    outlet: 'DCS_PixieNailSpa_TheWoodleighMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Nailed It Waxing And Threading (KL East Mall)",
    outlet: 'KLEastMall_NailedItWaxingAndThreading',
    account: ['kw@tunai', 'king.auto@tunai', 'qistina@tunai'],
  },
  {
    name: "Xuan Beauty (West Mall)",
    outlet: 'DTS_XuanBeauty_WestMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "DC Lash (Sunway Velocity)",
    outlet: 'DCS_DCLash_SunwayVelocity',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "The Nail Status (The Seletar Mall)",
    outlet: 'DCS_TheNailStatus_TheSeletarMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "Bio Organicare (Sengkang Grand Mall)",
    outlet: 'DCS_BioOrganicare_SengkangGrandMall',
    account: ['kw@tunai', 'king.auto@tunai'],
  },
  {
    name: "The Lufts Barber (Sunway Big Box Village)",
    outlet: 'DCS_TheLuftsBarber_SunwayBigBoxVillage',
    account: ['kw@tunai', 'king.auto@tunai', 'qistina@tunai'],
  },
  {
    name: "Kate Nail & Spa (IOI Mall Puchong)",
    outlet: 'DCS_KateNailAndSpa_IOIMallPuchong',
    account: ['kw@tunai', 'king.auto@tunai'],
  },

  
  
  
]


// const POS_INTEGRATION_MAP = POS_INTEGRATION_LIST.reduce(function(result, item, index, array) {
//   result[item.key || index] = item;
//   return result;
// }, {});


export default{
    POS_INTEGRATION_LIST,
    // POS_INTEGRATION_MAP,
}